import { countryReducerConstant, globalConstants } from "../../constants";

const { SUCCESS } = globalConstants;

const {
  GET_ALL_CITIES,
  GET_ALL_COUNTRIES,
  GET_ALL_STATES,
  RESET_CITIES,
  RESET_STATES,
  ALL_LANGUAGES,
} = countryReducerConstant;

const initialState = {
  allCountries: [],
  allStates: [],
  allCities: [],
  allLanguages: [],
};

export const countryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_COUNTRIES + SUCCESS:
      return { ...state, allCountries: action.data };
    case GET_ALL_STATES + SUCCESS:
      return { ...state, allStates: action.data };
    case GET_ALL_CITIES + SUCCESS:
      return { ...state, allCities: action.data };
    case RESET_STATES + SUCCESS:
      return { ...state, allStates: [] };
    case RESET_CITIES + SUCCESS:
      return { ...state, allCities: [] };
    case ALL_LANGUAGES + SUCCESS:
      return { ...state, allLanguages: action.data };
    default:
      return state;
  }
};
